import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SectionLabel } from "./SectionLabel";
import { PILLAR_PREVIEWS, fadeUp, stagger } from "./constants";

export default function EliteOverview() {
  return (
    <section className="py-24 md:py-28 bg-[#FEFDFB] text-[#0D1F17]">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <motion.div {...fadeUp} className="max-w-3xl mx-auto text-center mb-16">
          <SectionLabel>Program Overview</SectionLabel>
          <h2 className="font-serif text-3xl sm:text-4xl text-[#0D1F17] mt-4 mb-6">
            A fertility protocol, not a diet plan
          </h2>
          <p className="text-[#0D1F17]/60 leading-relaxed text-base">
            Fitly Elite is a fully online precision fertility biohacking program for individuals and couples trying to conceive.
            Built around five interconnected biological systems, with a structured 12-week curriculum so you build
            real nutrition literacy — not just short-term compliance.
          </p>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-5" data-testid="pillar-previews">
          {PILLAR_PREVIEWS.map((p, i) => (
            <motion.div key={p.title} {...stagger(i)} data-testid={`pillar-preview-${i}`}
              className="relative w-full sm:w-[calc(50%-10px)] lg:w-[calc(33.333%-14px)] bg-white border border-[#0D1F17]/6 rounded-2xl p-7 shadow-sm hover:shadow-md transition-shadow overflow-hidden group">
              <div className="absolute top-0 left-0 w-1 h-full rounded-l-2xl transition-all group-hover:w-1.5" style={{ backgroundColor: p.color }} />
              <div className="flex items-center gap-3.5 mb-4">
                <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: `${p.color}18`, border: `1px solid ${p.color}30` }}>
                  <p.icon size={20} style={{ color: p.color }} />
                </div>
                <h4 className="font-serif text-base text-[#0D1F17] leading-snug">{p.title}</h4>
              </div>
              <p className="text-sm text-[#0D1F17]/60 leading-[1.75] pl-[3.25rem]">{p.benefit}</p>
            </motion.div>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 mt-12">
          {[
            "12-week structured curriculum",
            "Individual & couple tracks",
            "100% online — pan-India",
            "Weekly live group calls",
            "Personalized meal plans",
            "Multi-specialist care team",
          ].map((point) => (
            <motion.div key={point} {...stagger(0)} className="flex items-center gap-2.5">
              <div className="w-5 h-5 rounded-full bg-[#0D1F17] flex items-center justify-center flex-shrink-0">
                <Check size={10} className="text-[#D4AF37]" />
              </div>
              <span className="text-sm text-[#0D1F17]/70">{point}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
